import { useEffect } from 'react'
import { useAuth } from './useAuth'
import { PATHS } from '@/lib/routes'

/** Match V1 — 5 minutes of inactivity triggers auto-logout */
const INACTIVITY_TIMEOUT_MS = 5 * 60 * 1_000

const ACTIVITY_EVENTS = [
  'mousedown',
  'mousemove',
  'keypress',
  'scroll',
  'touchstart',
  'click',
  'visibilitychange',
] as const

/**
 * Monitors user activity and signs out after 5 minutes of inactivity.
 * Mount inside AppLayout (protected routes only — not on /login).
 */
export function InactivityWatcher() {
  const { signOut } = useAuth()

  useEffect(() => {
    let lastActivity = Date.now()

    function resetTimer() {
      lastActivity = Date.now()
    }

    function checkInactivity() {
      if (Date.now() - lastActivity >= INACTIVITY_TIMEOUT_MS) {
        signOut({ redirectTo: PATHS.login })
      }
    }

    ACTIVITY_EVENTS.forEach(e => window.addEventListener(e, resetTimer))
    const interval = setInterval(checkInactivity, 10_000) // check every 10 s

    return () => {
      ACTIVITY_EVENTS.forEach(e => window.removeEventListener(e, resetTimer))
      clearInterval(interval)
    }
  }, [signOut])

  return null
}
